import * as React from "react";
import DocumentTitle from "react-document-title";
import Grid from "@material-ui/core/Grid";
import { observer } from "mobx-react-lite";
import { ParentsProfilesTable } from "../../features/Tables/ParentsProfilesTable/ParentsProfilesTable";
import { ParentsSearch } from "../../features/ParentsSearch/ParentsSearch";
import { useGetUsers } from "../../helpers/hooks/useGetUsers";
import { UserRoleEnum } from "../../static/enums/UserRole";
import { uiStore } from "../../mobx/stores/UiStore/UiStore";

export const ParentsProfilesPage = observer(() => {
  const { loading } = uiStore;
  useGetUsers({ role: UserRoleEnum.parent });

  return (
    <DocumentTitle title={"Родители - Mindset.Digital"}>
      <Grid container spacing={3}>
        <ParentsSearch loading={loading} />
        <ParentsProfilesTable loading={loading} />
      </Grid>
    </DocumentTitle>
  );
});
